import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sidePanel from 'side-panel-menu-thing'
// import * as basicScroll from 'basicscroll' //enqueued
import CareersModal from '../components/popup-careers.svelte'
//
const { $ } = window

const $body = $(document.body)

export default {
   init() {
      gsap.registerPlugin(ScrollTrigger)
      const mobileMenu = new sidePanel({
         target: $body[0],
         props: {
            target: $body[0],
            content: document.getElementById('mobile-menu'),
            fixed: true,
            width: 320,
         },
      })
      $('#toggle_nav').on('click', mobileMenu.show)

      $(document).on(
         'click', 
         '.menu-section .menu-item-has-children > a',
         function (e) {
            e.preventDefault()
            let $el = $(this)
            $el.parent().toggleClass('show-subnav')
         }
      )

      // $('.back-link a').click((e) => {
      //    e.preventDefault()
      //    history.back()
      // })

      //wrap hero stat numbers in span for countUp
      document.querySelectorAll('.stat-heading').forEach((h) => {
         let text = h.innerText
         // let span = document.createElement('span')
         // span.innerText = text.replace(/[^0-9\.]+/g,"").toString()
         let innerText = `<span data-count="${text
            .replace(/[^0-9\.]+/g, '')
            .toString()}">0</span>`
         h.innerHTML = text.replace(/[0-9\.]+/g, innerText)
      })

      let $careersBtn = $('.btn-careers > *')
      if ($careersBtn.length) {
         $careersBtn.attr('data-lity', 'Careers')
         let renderCount = 0
         $careersBtn.click((e) => {
            e.preventDefault()
            animateShow(renderCount)
            // console.log(renderCount)
         })

         new CareersModal({
            target: document.body,
            props: {
               // eslint-disable-next-line no-undef
               content: careersPUDetails,
            }, //footer.php
         })
      }

      const disclaimers = $('.disclaimer')

      if (disclaimers.length) {
         gsap.to(disclaimers, {
            scrollTrigger: {
               trigger: disclaimers,
               start: 'top 90%',
            },
            opacity: 1,
            stagger: 0.1,
            y: 0,
         })
      }

      animate()

      if (
         !$body.hasClass('page-template-team') &&
         !$body.hasClass('single-team')
      ) {
         sessionStorage.removeItem('selectedTeam')
      } else {
         $('.loc-switch a').on('click', function() {
            sessionStorage.removeItem('selectedTeam')
         })
      }
   },
   finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
      // class to hide outlines if not using keyboard
      $body.on('mousedown', function () {
         $body.addClass('using-mouse')
      })
      $body.on('keydown', function () {
         $body.removeClass('using-mouse')
      })

      //countUp Animation
      // if (document.body.classList.contains)
      // Observer setup
      let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
         if (entry.isIntersecting && entry.intersectionRatio === 1) {
            let $this = $(entry.target),
               countTo = $this.attr('data-count');

            // Prevent running more than once
            if ($this.data('counted')) return;
            $this.data('counted', true);

            $({ countNum: 0 }).animate(
            { countNum: countTo },
            {
               duration: 1000,
               easing: 'linear',
               step(now) {
                  $this.text(Math.floor(now));
               },
               complete() {
                  $this.text(countTo);
               }
            }
            );

            // If you only ever want it once, unobserve
            observer.unobserve(entry.target);
         }
      });
      }, {
      threshold: 1.0 // requires element to be fully visible
      });

      // Attach observer to each element
      $('.stat-heading span').each(function() {
      observer.observe(this);
      });

      if (
         //$body.hasClass('single-team') ||
         $body.hasClass('single-leadership')
      ) {
         if (document.referrer) {
            let cururl = new URL(window.location.href)
            let tmp = new URL(document.referrer)
            if (tmp.origin == cururl.origin) {
               $('.back-link a').attr(
                  'href',
                  document.referrer + '#team-section-wrap'
               )
            } else {
               console.log(doocument.referrer)
            }
         }
      }
      if ($body.hasClass('single-team')) {
         $('.back-link').on('click', (e) => {
            if (document.referrer) {
               e.preventDefault()
               // history.back()
               window.location.href = document.referrer
            }
         })
      }

      const $eventsAttendeesFilter = $('.events-attendees--filter')
      if( $eventsAttendeesFilter.length ) {
         const $eventsAttendeesFilterItems = $eventsAttendeesFilter.find('.tf-dropdown-list-element-item-all')
         if( $eventsAttendeesFilterItems.length ) {
            $eventsAttendeesFilterItems.addClass('tf-dropdown-list-element-item-selected')
            $eventsAttendeesFilterItems.addClass('tf-dropdown-list-element-item-active')
         }
      }

   },
}

function animate() {
   //! gsap.set('.footer-links li, .footer-locations > div, .footer-bottom', {y:16})
   animateTrendlines()
   animateCTA()
   animateFooter()
}
function animateTrendlines() {
   if (!$('.trendlines').length) {
      return
   }

   setTimeout(() => {
      let tl = gsap.timeline({
         scrollTrigger: {
            trigger: '.trendlines',
            start: window.matchMedia('(max-width: 700px)').matches
               ? 'top 90%'
               : 'center bottom',
            // toggleAction: 'play none none reverse',
            // markers: true
         },
      })

      let d = 0.35
      let settings = {
         opacity: 1,
         duration: d,
         ease: 'power1.out',
         stagger: 0.1,
      }

      gsap.set('.trendlines h2', { x: -32 })
      if ($('.trendlines > p').length) {
         gsap.set('.trendlines > p', { y: 32 })
      }
      // if ($('.trendlines > .btn').length) {
      //    gsap.set('.trendlines > .btn', {y: -32})
      // }
      gsap.set('.trendline-articles .article-card-wrap', { y: 32 }, `+=${d}`)
      tl.to('.trendlines h2', Object.assign(settings, { x: 0 }))
      if ($('.trendlines > p').length) {
         tl.to('.trendlines > p', Object.assign(settings, { y: 0 }), `-=${d}`)
      }
      if ($('.trendlines > .btn').length) {
         tl.to('.trendlines > .btn', Object.assign(settings, { y: 0 }), `-=${d}`)
      }
      tl.to(
         '.trendline-articles .article-card-wrap',
         Object.assign(settings, { y: 0 }),
         `-=${d}`
      )
   }, 1000)
}
function animateCTA() {
   if (!$('.call-to-action').length) {
      return
   }
   setTimeout(() => {
      let tl = gsap.timeline({
         scrollTrigger: {
            trigger: '.call-to-action',
            start: 'center bottom',
            // toggleAction: 'play none none reverse',
            // markers: true
         },
      })

      let d = 0.35
      let settings = {
         opacity: 1,
         duration: d,
         ease: 'power1.out',
         stagger: 0.1,
      }

      gsap.set('.call-to-action h2', { x: -32 })
      if ($('.call-to-action p').length) {
         gsap.set('.call-to-action p', { y: 32 })
      }
      // if ($('.call-to-action .btn').length) {
      //    gsap.set('.call-to-action .btn', {y: -32})
      // }
      tl.to('.call-to-action h2', Object.assign(settings, { x: 0 }))
      if ($('.call-to-action p').length) {
         tl.to('.call-to-action p', Object.assign(settings, { y: 0 }), `-=${d}`)
      }
      if ($('.call-to-action .btn').length) {
         tl.to('.call-to-action .btn', Object.assign(settings, { y: 0 }), `-=${d}`)
      }
   }, 1000)
}
function animateFooter() {
   let d = 0.2
   setTimeout(() => {
      gsap.set('.footer-links li, .footer-locations > div', { y: 16 })
      gsap.to('.footer-links li', {
         scrollTrigger: { trigger: '.footer-links' },
         y: 0,
         opacity: 1,
         duration: d,
         ease: 'power1.out',
         stagger: 0.05,
      })
      gsap.to(
         '.footer-locations > div',
         {
            scrollTrigger: { trigger: '.footer-locations' },
            y: 0,
            opacity: 1,
            duration: d,
            ease: 'power1.out',
            stagger: 0.05,
         },
         `+=${d * 2}`
      )
      gsap.to('.footer-bottom-grid', {
         scrollTrigger: { trigger: '.footer-bottom-grid' },
         opacity: 1,
         duration: d,
         ease: 'power1.out',
         stagger: 0.05,
      })
   }, 1000)
}

function animateShow() {
   //TODO dup?
   // setTimeout(() => $('html').addClass('mm-open'), 200)
   const tl = gsap.timeline({})
   let textWrapper = document.querySelector('.modal h2')
   let spanCheck = textWrapper.querySelectorAll('.word')
   if (!spanCheck.length) {
      textWrapper.innerHTML = textWrapper.textContent.replace(
         /\S+/g,
         "<span class='word'>$&</span>"
      )
   }

   gsap.set('.modal h2 .word', { opacity: 0, y: 24, x: 0, rotateZ: 0 })
   gsap.set('.modal h2 ~ *', { opacity: 0, y: 24 })
   tl.to('.modal h2 .word', {
      delay: 0.2,
      duration: 0.5,
      ease: 'elastic.out(1,0.5)',
      opacity: 1,
      rotateZ: 0,
      stagger: 0.075,
      x: 0,
      y: 0,
   }).to(
      '.modal h2 ~ *',
      {
         duration: 0.3,
         ease: 'power1.out',
         opacity: 1,
         y: 0,
      },
      '-=0.5'
   )

   // setTimeout(() => {
   //    console.log($('.lity-wrap'))
   //    $('.lity-wrap').on('click', (e) => {
   //       e.stopPropagation()
   //       console.log('click')
   //    })
   // }, 150)
}
